/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { ClockingDto } from '../models/ClockingDto';
import type { ClockingHistoryDto } from '../models/ClockingHistoryDto';
import type { ClockingStatusDto } from '../models/ClockingStatusDto';
import type { QSClockingReportDto } from '../models/QSClockingReportDto';
import type { SoHeaderClockingsDto } from '../models/SoHeaderClockingsDto';
import type { TechUtilisationReportResponsePagedListData } from '../models/TechUtilisationReportResponsePagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClockingService {

  /**
   * @param repairOrderJobId 
   * @returns ClockingDto Success
   * @throws ApiError
   */
  public static getClocking(
repairOrderJobId: number,
): CancelablePromise<ClockingDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/{repairOrderJobId}',
      path: {
        'repairOrderJobId': repairOrderJobId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param repairOrderJobId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postClocking(
repairOrderJobId: number,
requestBody?: ClockingStatusDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/clocking/{repairOrderJobId}',
      path: {
        'repairOrderJobId': repairOrderJobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param repairOrderJobIds 
   * @returns ClockingDto Success
   * @throws ApiError
   */
  public static getClocking1(
repairOrderJobIds?: Array<number>,
): CancelablePromise<Array<ClockingDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking',
      query: {
        'repairOrderJobIds': repairOrderJobIds,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns SoHeaderClockingsDto Success
   * @throws ApiError
   */
  public static getClockingBySoheaderId(
id: number,
): CancelablePromise<SoHeaderClockingsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/by-soheader-id/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param repairOrderJobId 
   * @returns ClockingHistoryDto Success
   * @throws ApiError
   */
  public static getClockingHistory(
repairOrderJobId: number,
): CancelablePromise<Array<ClockingHistoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/{repairOrderJobId}/history',
      path: {
        'repairOrderJobId': repairOrderJobId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param repairOrderJobIds 
   * @returns ClockingHistoryDto Success
   * @throws ApiError
   */
  public static getClockingHistory1(
repairOrderJobIds?: Array<number>,
): CancelablePromise<Record<string, Array<ClockingHistoryDto>>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/history',
      query: {
        'repairOrderJobIds': repairOrderJobIds,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns ClockingHistoryDto Success
   * @throws ApiError
   */
  public static getClockingHistoryBySoheader(
soHeaderId: number,
): CancelablePromise<Array<ClockingHistoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/{soHeaderId}/history-by-soheader',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postClockingExist(
id: number,
requestBody?: ClockingStatusDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/clocking/exist/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param date 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param employerName 
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns TechUtilisationReportResponsePagedListData Success
   * @throws ApiError
   */
  public static getClockingTechUtilisationReport(
date: string,
branch: BranchType,
employerName?: string,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<TechUtilisationReportResponsePagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/tech-utilisation-report',
      query: {
        'Date': date,
        'EmployerName': employerName,
        'Branch': branch,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns QSClockingReportDto Success
   * @throws ApiError
   */
  public static getClockingQsClockingReport(
soHeaderId: number,
): CancelablePromise<QSClockingReportDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/clocking/{soHeaderId}/qs-clocking-report',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
